import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    '& th': {
      color: theme.palette.common.white,
      fontWeight: 'bold'
    }
  },
  flagCell: {
    fontSize: '1.5rem'
  },
  percentageCell: {
    fontWeight: 'bold'
  },
  noDataContainer: {
    padding: theme.spacing(4),
    textAlign: 'center'
  },
  noDataText: {
    color: theme.palette.text.secondary
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4),
    minHeight: '200px'
  }
}));

const StatisticsTable = ({ data, loading }) => {
  const classes = useStyles();

  // Mostrar indicador de carga
  if (loading) {
    return (
      <Paper className={classes.tableContainer}>
        <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box>
      </Paper>
    );
  }

  // Mostrar mensaje si no hay datos
  if (!data || data.length === 0) {
    return (
      <Paper className={classes.tableContainer}>
        <Box className={classes.noDataContainer}>
          <Typography variant="h6" className={classes.noDataText}>
            No hay contactos disponibles para analizar
          </Typography>
        </Box>
      </Paper>
    );
  }

  // Mostrar tabla con datos
  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table>
        <TableHead className={classes.tableHeader}>
          <TableRow>
            <TableCell>Bandera</TableCell>
            <TableCell>País</TableCell>
            <TableCell>Código</TableCell>
            <TableCell align="right">Clientes</TableCell>
            <TableCell align="right">Porcentaje</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.countryCode} hover>
              <TableCell className={classes.flagCell}>
                {row.flag}
              </TableCell>
              <TableCell>{row.countryName}</TableCell>
              <TableCell>{row.dialCode}</TableCell>
              <TableCell align="right">{row.count.toLocaleString()}</TableCell>
              <TableCell align="right" className={classes.percentageCell}>
                {row.percentage.toFixed(2)}%
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StatisticsTable;
